import React from 'react';
import useSessionActivity from '../hooks/useSessionActivity';

/**
 * Provider component for session activity tracking
 * Must be placed inside a Router context
 */
const SessionActivityProvider = ({ children }) => {
  const sessionTimeoutMinutes =
    parseInt(process.env.REACT_APP_SESSION_TIMEOUT_MINUTES) || 60;

  useSessionActivity({
    timeoutMinutes: sessionTimeoutMinutes,
    logoutEndpoint: 'users/logout',
    loginPath: '/login',
    enabled: true,
  });

  return children;
};

export default SessionActivityProvider;
